import { BASE_URL } from 'entities/Seo/config';
import type { ICreateSchemaParams } from 'entities/Seo/types';

export const mapBreadcrumbListToSchema = ({ seo, path }: ICreateSchemaParams) => {
  if (!seo?.breadcrumbs) {
    return undefined;
  }

  return {
    '@type': 'BreadcrumbList',
    '@id': `${BASE_URL}${path}#breadcrumb`,
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Главная', item: `${BASE_URL}/` },
      ...seo.breadcrumbs.map((breadcrumb, idx) => ({
        '@type': 'ListItem',
        position: idx + 2,
        name: breadcrumb.title,
        item: `${BASE_URL}${breadcrumb.url}`,
      })),
    ],
  };
};
